<template>
  <div id="selected-products">
    <h2 id="selected-products-title">
      {{ $t('newCartPage.title') }}
    </h2>
    <p
      id="selected-products-subtitle"
      style="white-space: pre-line; padding-left: 10px; font-size: 16px;"
    >
      {{ $t('newCartPage.description') }}
    </p>
    <v-form
      v-if="!$store.getters.isSelectedEmpty"
      ref="form"
      lazy-validation
    >
      <div
        class="cart-list-actions"
        style="width:100%; display:flex; justify-content: space-between;"
      >
        <v-layout
          row
          wrap
          align-center
          justify-center
        >
          <v-flex
            class="cart-list-actions-left"
            sm6
            xs12
          >
            <v-btn
              color="error"
              class="delete-all-btn"
              @click="onClearBtnClick"
            >
              {{ $t('newCartPage.removeAll') }}
            </v-btn>
          </v-flex>
          <v-flex
            class="cart-list-actions-right"
            sm6
            xs12
          >
            <v-btn-toggle
              class="layout-switch"
              v-model="layout"
              mandatory
            >
              <v-btn flat value="oneCol" @click="changeLayout('oneCol')">
                <img :src="require('../../assets/one_col.png')" width="20px" height="16px"/>
              </v-btn>
              <v-btn flat value="twoCol" @click="changeLayout('twoCol')">
                <img :src="require('../../assets/two_col.png')" width="20px" height="16px"/>
              </v-btn>
              <v-btn flat value="card" @click="changeLayout('card')">
                <img :src="require('../../assets/grid_col.png')" width="20px" height="16px"/>
              </v-btn>
            </v-btn-toggle>
            <v-btn
              color="info"
              class="submit-btn"
              @click="validate"
            >
              {{ $t('newCartPage.submitOrder') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
      <h2>{{ $t("variables.PinkfongProducts") }} ({{ getProductList.length }})</h2>
      <list
        :items="getProductList"
        model-name="pinkfongproducts"
        :is-select="true"
        :card-layout="layout"
        :flex-class="'pa-3'"
        :list-break-point="pinkfongBreakpoint"
      >
        <template slot-scope="props">
          <h3>{{ props.item.name }}</h3>
          <div class="mt-1">
            {{ props.item.category.name }} ({{ props.item.age }})<br>
            {{ $t("variables.manufacturer") }}: {{ props.item.manufacturer }}
          </div>
          <v-btn
            style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
            @click.stop="linkTo(getDetailUrl(props.item))"
          >
            {{ $t("variables.viewDetail") }}
          </v-btn>
        </template>
      </list>
      <h2>{{ $t("variables.LicensedProducts") }} ({{ getLicenseList.length }})</h2>
      <list
        :items="getLicenseList"
        model-name="licensedproducts"
        :is-select="true"
        :card-layout="layout"
        :flex-class="'pa-3'"
        :list-break-point="licenceBreakpoint"
      >
        <template slot-scope="props">
          <h3>{{ props.item.name }}</h3>
          <div class="mt-1">
            {{ props.item.category.name }} ({{ props.item.age }})<br>
            {{ $t("variables.manufacturer") }}: {{ props.item.manufacturer }}
          </div>
          <v-btn
            style="margin: 20px 0 0 0; width: 100%; text-transform: inherit;"
            @click.stop="linkTo(getDetailUrl(props.item))"
          >
            {{ $t("variables.viewDetail") }}
          </v-btn>
        </template>
      </list>
      <div
        class="cart-list-actions"
        style="width:100%; display:flex; justify-content: space-between;"
      >
        <v-layout
          row
          wrap
          align-center
          justify-center
        >
          <v-flex
            class="cart-list-actions-left"
            sm6
            xs12
          >
            <v-btn
              color="error"
              class="delete-all-btn"
              @click="onClearBtnClick"
            >
              {{ $t('newCartPage.removeAll') }}
            </v-btn>
          </v-flex>
          <v-flex
            class="cart-list-actions-right"
            sm6
            xs12
          >
            <v-btn
              color="info"
              class="submit-btn"
              @click="validate"
            >
              {{ $t('newCartPage.submitOrder') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </div>
    </v-form>
    <div
      v-else
      id="selected-products-empty"
    >
      <img
        :src="require('../../assets/empty_cart.png')"
        style="margin-left: -33px;"
      >
      <p id="selected-products-empty-title">
        {{ $t("newCartPage.emptyList") }}
      </p>
    </div>
    <v-dialog
      v-model="dialog"
      max-width="600"
      :persistent="true"
    >
      <v-form
        ref="modalForm"
        lazy-validation
      >
        <v-card>
          <v-card-title class="headline">
            {{ $t("newCartPage.orderTitle") }}
          </v-card-title>

          <v-card-text style="padding-bottom: 30px; white-space: pre-line;">
            {{ $t("newCartPage.orderSubtitle") }}
          </v-card-text>
          <div class="order-sheet-row">
            <p>
              {{ "*" + $t("newCartPage.company") }}
            </p>
            <v-text-field
              v-model.trim="orderSheet.company"
              class="quantity-field"
              single-line
              :rules="[() => !!orderSheet.company || $t('newCartPage.orderFieldErrorRequired') ]"
              required
            />
          </div>
          <div class="order-sheet-row">
            <p>
              {{ $t("newCartPage.manager") }}
            </p>
            <v-text-field
              v-model.trim="orderSheet.name"
              class="quantity-field"
              single-line
            />
          </div>
          <div class="order-sheet-row">
            <p>
              {{ "*" + $t("newCartPage.email") }}
            </p>
            <v-text-field
              v-model.trim="orderSheet.email"
              class="quantity-field"
              single-line
              :rules="[
                () => !!orderSheet.email || $t('newCartPage.orderFieldErrorRequired'),
                () => isEmail(orderSheet.email) || $t('newCartPage.orderFieldErrorEmail')]"
              required
            />
          </div>
          <div class="order-sheet-row">
            <p>
              {{ "*" + $t("newCartPage.saleRegion") }}
            </p>
            <v-text-field
              v-model.trim="orderSheet.saleRegion"
              class="quantity-field"
              single-line
              :rules="[() => !!orderSheet.saleRegion || $t('newCartPage.orderFieldErrorRequired'),]"
              required
            />
          </div>
          <div class="order-sheet-row">
            <p>
              {{ $t("newCartPage.contact") }}
            </p>
            <v-text-field
              v-model.trim="orderSheet.contact"
              class="quantity-field"
              single-line
            />
          </div>
          <div class="order-sheet-row">
            <p>
              {{ $t("newCartPage.orderList") }}
            </p>
            <div style="width:100%; max-height: 200px; overflow-y: scroll; background-color: rgba(244,244,244,0.5); padding:0px;">
              <table style="border-collapse: collapse;">
                <tr style="">
                  <th>
                    <div
                      class="table-div title-col"
                    >
                      {{ $t("newCartPage.orderProduct") }}
                    </div>
                  </th>
                  <th>
                    <div class="table-div">
                      {{ $t("newCartPage.orderQuantity") }}
                    </div>
                  </th>
                  <th>
                    <div class="table-div">
                      {{ $t("newCartPage.orderRequest") }}
                    </div>
                  </th>
                </tr>
                <tr
                  v-for="item in getTotalList()"
                  :key="item.orderCode"
                >
                  <td>
                    <div
                      class="table-div title-col"
                    >
                      {{ item.name }} {{ getOptionNameByCode(item, item.orderCode) }}
                    </div>
                  </td>
                  <td>
                    <div class="table-div">
                      {{ parseInt(item.orderQuantity).toLocaleString() }}
                    </div>
                  </td>
                  <td>
                    <div class="table-div">
                      {{ item.orderDescription ? item.orderDescription : '' }}
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="order-sheet-row">
            <v-checkbox
              v-model="orderSheet.isAgree"
              :rules="[v => !!v || '']"
              :label="$t('newCartPage.agreeMessage')"
              required
            />
          </div>
          <v-card-actions class="order-sheet-action">
            <v-btn
              color="rgb(90 90 90)"
              flat="flat"
              @click="dialog = false"
            >
              {{ $t("newCartPage.close") }}
            </v-btn>
            <v-btn
              color="rgb(255 103 175)"
              flat="flat"
              @click="submitOrder"
            >
              {{ $t("newCartPage.ok") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import List from 'components/List.vue'
import { mapGetters } from 'vuex'
import Swal from 'sweetalert2'

export default {
  components: {
    'list': List
  },
  data () {
    return {
      flagImg: require('../../assets/new_tag_l.png'),
      dialog: false,
      orderSheet: {
        company: null,
        name: null,
        email: null,
        saleRegion: null,
        contact: null,
        isAgree: false
      },
      layout: 'twoCol',
      onCol: true
    }
  },
  computed: {
    ...mapGetters({
      getLicenseList: 'getLicenseList',
      getProductList: 'getProductList'
    }),
    isOneCol () {
      return this.layout === 'oneCol'
    },
    pinkfongBreakpoint () {
      let retVal = {}
      switch (this.layout) {
        case 'oneCol':
          retVal = {
            'xs': 12,
            'sm': 12,
            'md': 12,
            'lg': 12,
            'xl': 12
          }
          break
        case 'twoCol':
          retVal = {
            'xs': 12,
            'sm': 6,
            'md': 6,
            'lg': 6,
            'xl': 6
          }
          break
        default:
          retVal = {
            'xs': 12,
            'sm': 6,
            'md': 4,
            'lg': 3,
            'xl': 3
          }
          break
      }
      return retVal
    },
    licenceBreakpoint () {
      let retVal = {}
      switch (this.layout) {
        case 'oneCol':
          retVal = {
            'xs': 12,
            'sm': 12,
            'md': 12,
            'lg': 12,
            'xl': 12
          }
          break
        case 'twoCol':
          retVal = {
            'xs': 12,
            'sm': 6,
            'md': 6,
            'lg': 6,
            'xl': 6
          }
          break
        default:
          retVal = {
            'xs': 12,
            'sm': 6,
            'md': 4,
            'lg': 3,
            'xl': 3
          }
          break
      }
      return retVal
    },
    mediaBreakpoint () {
      return {
        'xs': 12,
        'sm': 12,
        'md': 12,
        'lg': 12,
        'xl': 12
      }
    }
  },
  beforeMount () {
    this.layout = this.$store.getters.getSelectedLayout
  },
  methods: {
    changeLayout (val) {
      this.layout = val
      this.$store.commit('setLayout', val)
    },
    getTotalList () {
      const pinkfongProductList = Array.isArray(this.getProductList) ? this.getProductList : []
      const licensedProductList = Array.isArray(this.getLicenseList) ? this.getLicenseList : []

      return [
        ...pinkfongProductList,
        ...licensedProductList
      ]
    },
    getDetailUrl (item) {
      let category = this.$route.params.category ? this.$route.params.category : 'all'
      return '/' + this.$language.locale + '/' + item.product + '/' + category + '/' + item.code
    },
    linkTo (address) {
      this.$router.push(address)
    },
    validate () {
      if (!this.$refs.form.validate()) {
        this.orderSheet.isAgree = false
        Swal.fire({
          title: this.$t('newCartPage.quantityWarningTitle'),
          text: this.$t('newCartPage.quantityWarningDescription'),
          icon: 'error'
        })
      } else {
        this.dialog = true
      }
    },
    getOptionNameByCode (item, code) {
      if (item.option.length === 0) {
        return ''
      }
      const index = item.option.findIndex(x => x.code === code)
      return ' - ' + item.option[index].name
    },
    isEmail (asValue) {
      const regExp = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i
      return regExp.test(asValue)
    },
    submitOrder () {
      if (!this.$refs.modalForm.validate()) {
        Swal.fire({
          title: this.$t('newCartPage.orderFieldError'),
          icon: 'error'
        })
      } else {
        Swal.fire({
          title: this.$t('newCartPage.orderCreating'),
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          }
        })
        this.createOrder()
          .then((res) => {
            Swal.close()
            this.dialog = false
            Swal.fire({
              title: this.$t('newCartPage.orderLoading'),
              allowOutsideClick: false,
              onBeforeOpen: () => {
                Swal.showLoading()
              }
            })
            return this.sendEmail(res.data.new_order_id, this.orderSheet.company)
          })
          .then((res) => {
            Swal.close()
            Swal.fire({
              title: this.$t('newCartPage.orderSuccess'),
              icon: 'success'
            })
          })
          .catch((err) => {
            Swal.close()
            Swal.fire({
              title: this.$t('newCartPage.orderFailed'),
              content: err.response.data,
              icon: 'error'
            })
          })
      }
    },
    createOrder () {
      const lang = this.$route.path.split('/')[1]

      const products = []
      this.getTotalList().forEach(item => {
        let orderedProduct = {
          'productCode': item['code'],
          'quantity': item['orderQuantity'],
          'description': item['orderDescription'],
          'type': item['product']
        }
        // 옵션 존재할 경우 옵션 코드 파라미터 부여! 없을 경우 옵션 코드 빼야 함.
        if (item.option.length > 0) {
          orderedProduct['optionCode'] = item['orderCode']
        }
        products.push(orderedProduct)
      })
      const bodyFormData = new FormData()
      bodyFormData.append('company', this.orderSheet.company)
      bodyFormData.append('email', this.orderSheet.email)

      if (this.orderSheet.name) bodyFormData.append('manager', this.orderSheet.name)
      if (this.orderSheet.contact) bodyFormData.append('contact', this.orderSheet.contact)

      bodyFormData.append('lang', lang)
      bodyFormData.append('saleRegion', this.orderSheet.saleRegion)
      bodyFormData.append('products', JSON.stringify(products))

      return new Promise((resolve, reject) => {
        this.$http.post('/api/orders/create/', bodyFormData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
          .then(res => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    sendEmail (orderId, company) {
      return new Promise((resolve, reject) => {
        this.$http.get(`/api/orders/send/?order_id=${orderId}&company=${company}&lang=${this.$language.locale}`)
          .then(res => {
            resolve(res)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onClearBtnClick () {
      Swal.fire({
        title: this.$t('newCartPage.removeAllConfirm'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: 'rgb(255 103 175)',
        cancelButtonColor: 'rgb(90 90 90)',
        confirmButtonText: this.$t('newCartPage.ok'),
        cancelButtonText: this.$t('newCartPage.close')
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            this.$t('newCartPage.removeAllDone'),
            '',
            'success'
          )
          this.$store.commit('clearItem')
        }
      })
    }
  }
}
</script>
<style>
#selected-products{
  padding-top: 30px;
}

#selected-products #selected-products-title{
  font-size: 32px;
}

#selected-products #selected-products-subtitle{
  font-size: 14px;
  padding-top: 5px;
  margin-bottom: 30px;
}

#selected-products #selected-products-empty{
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 80px;
  flex-direction: column;
}

#selected-products #selected-products-empty #selected-products-empty-title{
  padding-top: 30px;
  margin: 0px;
  font-size: 24px;
  color: rgba(146, 146, 146, 0.9)
}

#selected-products .cart-list-actions{
  margin-top: 30px;
  margin-bottom: 30px;
}

#selected-products .cart-list-actions .cart-list-actions-right{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

#selected-products .cart-list-actions .cart-list-actions-left{
  display: flex;
  align-items: center;
  justify-content: start;
}

@media (max-width: 599px) {
  #selected-products .cart-list-actions .cart-list-actions-right {
    justify-content: center;
  }

  #selected-products .cart-list-actions .cart-list-actions-left{
    justify-content: center;
  }

  #selected-products .cart-list-actions .cart-list-actions-right button{
    width: 283px;
  }

  #selected-products .cart-list-actions .cart-list-actions-left button{
    width: 283px;
  }

  #selected-products .layout-switch{
    display: none;
  }
}

#selected-products .cart-list-actions .submit-btn{
  background-color: rgb(255 103 175) !important;
  border-color: rgb(255 103 175) !important;
  font-weight: bold;
}

#selected-products .cart-list-actions .delete-all-btn{
  background-color: rgb(90 90 90) !important;
  border-color: rgb(90 90 90) !important;
  font-weight: bold;
}

#selected-products #selected-products-list{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.v-overlay--active{
  transform: none !important;
}

.order-sheet-row{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 26px;
  padding-top: 0px;
}

.order-sheet-row .v-input{
  width: 100%;
  max-width: 300px;
}

.order-sheet-row .v-input.v-text-field.v-text-field--single-line.theme--light {
  padding: 0px;
  margin: 0px;
}

.order-sheet-row .v-input__control{
  height: 34px;
  position: relative;
}

.order-sheet-row .v-input__slot input{
  padding: 0px;
}

.order-sheet-row .v-text-field__details{
  padding: 0px;
  position: absolute;
  bottom: -17px;
}

.order-sheet-action{
  padding-top: 30px;
  display: flex;
  justify-content: flex-end;
}

.order-product-text-list{
  margin-bottom: 3px;
  font-size: 16px;
}

.order-sheet-row .table-div{
  min-width: 200px;
  padding-right: 30px;
  padding-left: 5px;
  word-break: break-word;
  margin-top: 6px;
  line-height: 16px;
}

.order-sheet-row .table-div.title-col{
  min-width: 230px;
  max-width: 300px;
}

.order-sheet-row th, .order-sheet-row td{
  text-align: left;
}

.order-sheet-row th{
  position: sticky;
  top: 0px;
  background-color: rgb(255 103 175);
}

.order-sheet-row th > div{
  color: white;
  border-bottom: 1px solid #444444;
  padding-bottom: 10px;
}

.swal2-actions .swal2-cancel{
  border-radius: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/app/contents/SelectedProducts.vue